import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ApiResponseModel, ApiVisa, BaseApiTemplateService, Core2Config } from "../../shared";
import { CompareGenDocSignatureRequestBody } from "../../../../../../models/dbschema";
import { Observable } from "rxjs";


@Injectable({providedIn: 'root'})
export class GenericDocSignatureService extends BaseApiTemplateService<any> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.ERP_PREFIX + 'generic-doc/signatures';
    this.endpoint_path = Core2Config.TENANT_URL_PREFIX  + Core2Config.DOMAIN_PREFIX + Core2Config.ERP_PREFIX + 'generic-doc/signatures';
    this.httpClient = http;
  }

  compareGenDocSignature(
    requestData: CompareGenDocSignatureRequestBody,
    visa: ApiVisa
  ): Observable<any> {
    let url = visa.api_domain_url + this.endpoint_path + "/compare-signatures";
    if (this.endpoint_path && visa.api_domain_url) {
      url =
        visa.api_domain_url +
        this.endpoint_path +
        "/compare-signatures";
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      url,
      requestData,
      this.getHttpHeader(visa)
    );
  }
}